const state = {
  admin: false,
};

export default state;
